import QueryString from 'qs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { authAxiosInstance } from '../../../utils/axiosConfig';
import { toast } from 'react-toastify';
import PageWithCard from '../../../components/infrastructure/PageWithCard';
import TableWithHeadingAndSearch from '../../../components/Table/TableWithHeadingAndSearch';

const QualityWiseInventory = () => {
    const { cuttingString } = useParams();
    const { cuttingCardRef, location } = JSON.parse(atob(cuttingString));
    const [loading, setLoading] = useState(false);
    const [inventoryData, setInventoryData] = useState([]);

    useEffect(() => {
        console.log('fetching in');
        const fetchInventory = async () => {
            try {
                setLoading(true);
                const string = QueryString.stringify({
                    cuttingCardRef,
                    location,
                });

                const resp = await authAxiosInstance.get(
                    `/inventory/cutting/byCard?${string}`
                );
                setInventoryData(resp.data.data.docs);
            } catch (error) {
                console.log(error);
                toast.error('Failed to fetch data');
            } finally {
                setLoading(false);
            }
        };
        fetchInventory();
    }, [cuttingString]);

    const cols = useMemo(() => {
        return [
            {
                Header: 'TAKA#',
                Cell: ({ row, data }) => {
                    return row.index + 1;
                },
            },
            {
                Header: 'location',
                accessor: 'location.name',
            },
            {
                Header: 'Grey Mt',
                accessor: 'cuttingCard.takaDetails.greyMt',
            },
            {
                Header: 'Mill Mt',
                accessor: 'cuttingCard.takaDetails.millMt',
            },
            {
                Header: 'Shortage %',
                accessor: 'cuttingCard.takaDetails.shortage',
            },
            {
                Header: 'Fresh',
                Cell: ({ row }) => {
                    return <div>{row.original['stagesMap']['fresh']}</div>;
                },
            },

            {
                Header: 'Second',
                Cell: ({ row }) => {
                    return <div>{row.original['stagesMap']['second']}</div>;
                },
            },
        ];
    }, [cuttingString]);
    return (
        <PageWithCard
            heading={`${loading ? 'Loading...' : inventoryData?.[0]?.cuttingCard?.cuttingCardNumber}`}
        >
            <TableWithHeadingAndSearch
                heading={'Inventory'}
                columns={cols}
                data={inventoryData}
            />
        </PageWithCard>
    );
};

export default QualityWiseInventory;
